module.exports = __webpack_public_path__ + "img/loading_small.92fcf840.webp";